export default __webpack_public_path__ + "static/media/1884.f13deb08.png";